module.exports = __webpack_public_path__ + "static/img/ios.4d0a737b.png";